import React, { useState, useEffect } from 'react'
import Nav from './Nav'
import { Modal, Form, Button } from 'react-bootstrap';
import emailjs from '@emailjs/browser';
import { emailJSInit } from '../helpers/variables';


export default function Classes() {

    useEffect(() => emailjs.init(emailJSInit), [])

    const [modalIsVisible, setModalIsVisible] = useState(false);

    // function handleSignUp() {
    //     setModalIsVisible(true)
    // }

    function handleClose() {
        setModalIsVisible(false)
    }

    function handleSubmit(event) {
        event.preventDefault()
        const formData = {name: event.target[1].value, email: event.target[2].value, message:  event.target[3].value}
        emailjs.send('service_03oqynp', 'template_21lpl62', formData)
        .then(
            (response) => {console.log('SUCCESS!', response.status, response.text);},
            (error) => {alert('FAILED...', error);}
        )
        .then(
            setModalIsVisible(false)
        );
    }

    return (
        <div className="page-content">
            <Nav />
            <main className='classes-page'>
                <div className='mt-4 classes-text'>
                    <div className='classes-intro-text'>
                        <h1>Available Classes</h1>
                        <p>Use my <a href='about'>general contact form</a> for all class inquiries.</p>
                        <p>I currently offer the following classes on a semi-regular basis, so if you don't have a group, you're welcome to join one already scheduled. I also occassionally do custom classes upon request - maybe you want to be fancy and learn how to make macarons or croissants. I typically need several weeks advance notice for all class requests.</p>
                        {/* <button className='primary-button' onClick={handleSignUp}>Sign up</button> */}
                        {/* TODO - Create form for custom class inquiry */}
                    </div>
                    <hr></hr>
                    <div className='p-3' style={{backgroundColor: "#FAE8DE"}}>
                        <div className='class-description'>
                            <h3>Introduction to Sourdough</h3>
                            <p>Interested in learning about baking sourdough but don't know where to start? Join me for a one hour class in my home where I will break down the basics and de-mystify taking care of a starter. You will leave with a jar of starter, my very own sourdough recipe, and some of my favorite tips and tricks!</p>
                            <p>Cost: $35</p>
                        </div>
                        <hr></hr>
                        <div className='class-description'>
                            <h3>Sourdough Workshop</h3>
                            <p>In this 2.5 hour class, you will learn to maintain a sourdough starter, mix dough by hand, shape, and score your sourdough. We will go through each step together, and you will go home with a proofing basket, dough scraper, sourdough starter, and the dough that you've mixed and shaped to take home and bake!</p>
                            <p>Cost: $75</p>
                        </div>
                    </div>
                </div>
                <div className='classes-image'>
                    <img src={require('../images/Maddie-98-min.jpg')} alt="Madelyn teaching a sourdough class" width="320px" />
                </div>
            </main>

            <Modal
                show={modalIsVisible}
                onHide={handleClose}
            >
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Class Interest Form</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Select from classes already scheduled */}
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" />
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Select class</Form.Label>
                            <Form.Select aria-label="Default select example">
                                <option>Open this select menu</option>
                                <option value="Introduction to Sourdough 9/22" disabled>Introduction to Sourdough ($25) - 9/22</option>
                                <option value="Sourdough Workshop 10/19" disabled>Sourdough Workshop ($65) - 10/19 - FULL</option>
                            </Form.Select>
                        </Form.Group>
                    </Modal.Body> 
                    <Modal.Footer>
                        <Button variant='secondary' onClick={handleClose}>Close</Button>
                        <button className='primary-button' type="submit">Submit</button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    )
}